import { TFunction } from "i18next";

export const staticTranslationFunction: TFunction = ((key: string) =>
  key) as unknown as TFunction;
